import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WeatherFactorPopupComponent } from './weather-factor-popup.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    WeatherFactorPopupComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule
  ],
  exports:[
    WeatherFactorPopupComponent
  ]
})
export class WeatherFactorPopupModule { }
